import { NotFound } from '../error/NotFound';
import { CatalogoComponent } from './CatalogoComponent';
import { useLocation } from 'react-router';
import { useResultadoRequest } from './useResultadoRequest';
import { LoadingComponent } from '../shared/LoadingComponent';
import { ErrorComponent } from '../error/ErrorComponent';
import { SinProductos } from './SinProductos';

export const RESULTADO_PATH = '/resultado';

export const Resultado = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const rubro = params.get('r');
  const busqueda = params.get('b');
  const [data, loading, error] = useResultadoRequest(rubro, busqueda);
  const showRubroFilter = !!rubro;
  const tituloInicio = busqueda ? 'Resultados de' : '';
  const titulo = data?.title?.trim && data.title.trim().length > 0 ? `${tituloInicio} ${data.title.trim()}` : '';

  if (!rubro && !busqueda) return <NotFound></NotFound>;

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorComponent />;

  const hayProductos = data?.products && data.products.length > 0;

  return (
    <>
      {hayProductos ? (
        <>
          <CatalogoComponent
            orden={0}
            data={data?.products}
            iconoRubro={data?.icon}
            moduloTitulo={titulo}
            showRubroFilter={showRubroFilter}
            rubroId={rubro != null ? rubro : undefined}
            legales={data.comments}
            isOnTop={true}
          />
        </>
      ) : (
        <SinProductos marginY={['50px', '100px', '150px']} />
      )}
    </>
  );
};
